import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const hintQuestionBannerSelector = (state: TAppState) => {
  const openChat = currentOpenChatSelector(state);

  return openChat?.hintQuestions.banner;
};
